export default __webpack_public_path__ + "static/media/frame-1.f2b3e36a.png";